import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import {
  CRM_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
  DEV_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
  INSTALL_PRODUCTS_FLOW
} from "constants/cookies";
import { CRM, SOFTWARE } from "constants/clusters.js";
import CrmVi from "/static/svg/crm-vi1.svg";
import DevVi from "/static/svg/dev-vi1.svg";
import WmVi from "/static/svg/wm-vi1.svg";

export const cookieValues = {
  [WORK_MANAGEMENT_PRODUCT_ID]: [
    {
      key: INSTALL_PRODUCTS_FLOW,
      value: false
    }
  ],
  [CRM_PRODUCT_ID]: [
    {
      key: CRM_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
      value: "new_with_big_signup_modal_for_products"
    },
    {
      key: INSTALL_PRODUCTS_FLOW,
      value: true
    }
  ],

  [DEV_PRODUCT_ID]: [
    {
      key: DEV_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
      value: "new_with_big_signup_modal_for_products"
    },
    {
      key: INSTALL_PRODUCTS_FLOW,
      value: true
    }
  ],

  [`${CRM_PRODUCT_ID}_${WORK_MANAGEMENT_PRODUCT_ID}`]: [
    {
      key: INSTALL_PRODUCTS_FLOW,
      value: true
    }
  ],

  [`${DEV_PRODUCT_ID}_${WORK_MANAGEMENT_PRODUCT_ID}`]: [
    {
      key: INSTALL_PRODUCTS_FLOW,
      value: true
    }
  ],

  [`${CRM_PRODUCT_ID}_${DEV_PRODUCT_ID}`]: [
    {
      key: INSTALL_PRODUCTS_FLOW,
      value: true
    }
  ]
};

export const procuctIdToCluster = {
  [CRM_PRODUCT_ID]: CRM,
  [DEV_PRODUCT_ID]: SOFTWARE
};

export const getViIcon = (productId) => {
  const ViMap = {
    [CRM_PRODUCT_ID]: <CrmVi />,
    [DEV_PRODUCT_ID]: <DevVi />,
    [WORK_MANAGEMENT_PRODUCT_ID]: <WmVi />
  };
  return Object.keys(ViMap).includes(productId) ? <div className="vi-sign">{ViMap[productId]}</div> : null;
};

export const HOSPITAL = "Hospital";
export const APPS = "Apps";
export const ILLUSTRATIVE = "Illustrative";
